import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import ProtectedRoute from "src/components/common/ProtectedTenantRoute";
import LoginPage from "./LoginPage";
import PublicInvoicePage from "./invoices/PublicInvoicePage";
import { appRoutes } from "./routes.config";

const AppRoutes: React.FC = () => {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      {/* Publicly shareable invoice link — intentionally outside
          ProtectedRoute, no login required to view/download. */}
      <Route path="/invoices/:invoiceId" element={<PublicInvoicePage />} />
      {appRoutes.map((r, idx) => (
        <Route
          key={idx}
          path={r.path}
          element={<ProtectedRoute>{r.element}</ProtectedRoute>}
        />
      ))}

      {/* Fallback redirect */}
      <Route path="/*" element={<Navigate to="/app/dashboard" replace />} />
    </Routes>
  );
};

export default AppRoutes;
